import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Button, Input } from 'hljd'
import style from './style.module.less'
import { observer } from 'mobx-react'
import { hashHistory, Link } from 'react-router'
import { JIAMENG_GOODS_PATH } from '@constant'
import Table from './Table'
import Store from './store'
const store = new Store()

@observer
class Index extends Component {
  componentWillUnmount() {
    store.reset()
  }
  render() {
    const header = [<Link to={JIAMENG_GOODS_PATH}>商品管理</Link>, '婚品管理']
    return (
      <HeaderView
        title="婚品管理"
        header={header}
        extra={
          <div>
            <Button
              type="primary"
              onClick={() =>
                hashHistory.push(
                  '/localMerchant/jiaMengGoods/weddingSupervise/add'
                )
              }
            >
              添加直供商品
            </Button>
          </div>
        }
      >
        <div className={style.weddingSeperviseGoodsWrap}>
          <div className="search-box">
            <Input
              placeholder="请输入婚品名称"
              style={{ width: '240px', marginRight: '20px' }}
              onChange={e => store.setStoreData('keyword', e.target.value)}
            />
            <Button type="primary" onClick={store.search}>
              搜索
            </Button>
          </div>
          <div className="goods-count">上架商品{store.totalCount}</div>
          <Table store={store} />
        </div>
      </HeaderView>
    )
  }
}
export default Index
